import { render, staticRenderFns } from "./m-iit-sign-plugin.vue?vue&type=template&id=5a9aa4ed&scoped=true&lang=pug&"
import script from "./m-iit-sign-plugin.vue?vue&type=script&lang=js&"
export * from "./m-iit-sign-plugin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a9aa4ed",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
